<ng-container
  *ngIf="{
    qty: qty$ | async,
  } as content"
>
  {{ content.qty }}
</ng-container>
